export const TempratureIcon1 = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="1 0 26 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.8424 13.6875C25.3947 13.6875 25.8424 14.1352 25.8424 14.6875C25.8424 22.4058 20.148 27.6091 13.1521 27.6091C7.54835 27.6091 2.88185 24.6171 1.24416 19.7766C1.06716 19.2535 1.34777 18.6859 1.87092 18.5089C2.39408 18.3319 2.96166 18.6125 3.13867 19.1356C4.45752 23.0337 8.26011 25.6091 13.1521 25.6091C19.0697 25.6091 23.8424 21.2751 23.8424 14.6875C23.8424 14.1352 24.2901 13.6875 24.8424 13.6875Z"
        fill="#219653"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6905 3.76604C6.77294 3.76604 2.00024 8.10001 2.00024 14.6876C2.00024 15.2399 1.55252 15.6876 1.00024 15.6876C0.447952 15.6876 0.000236512 15.2399 0.000236512 14.6876C0.000236512 6.96932 5.69467 1.76604 12.6905 1.76604C18.2955 1.76604 22.9608 4.75811 24.5985 9.59849C24.7755 10.1216 24.4949 10.6892 23.9717 10.8662C23.4485 11.0432 22.881 10.7626 22.704 10.2395C21.3851 6.34134 17.5836 3.76604 12.6905 3.76604Z"
        fill="#219653"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.22225 19.2139C1.3562 18.6781 1.89913 18.3523 2.43493 18.4863L7.20355 19.6784C7.73935 19.8124 8.06511 20.3553 7.93116 20.8911C7.79721 21.4269 7.25428 21.7527 6.71848 21.6187L2.92 20.6691L1.97038 24.4676C1.83643 25.0034 1.2935 25.3291 0.757701 25.1952C0.221906 25.0612 -0.103855 24.5183 0.0300941 23.9825L1.22225 19.2139Z"
        fill="#219653"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.0859 4.18044C25.6217 4.31439 25.9475 4.85733 25.8135 5.39312L24.6214 10.1617C24.4874 10.6975 23.9445 11.0233 23.4087 10.8894L18.6401 9.6972C18.1043 9.56325 17.7785 9.02031 17.9124 8.48452C18.0464 7.94872 18.5893 7.62296 19.1251 7.75691L22.9236 8.70653L23.8732 4.90805C24.0072 4.37225 24.5501 4.04649 25.0859 4.18044Z"
        fill="#219653"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.36879 11.7545C6.5332 11.4027 6.88642 11.1779 7.27475 11.1779H17.9414C18.3297 11.1779 18.683 11.4027 18.8474 11.7545C19.0118 12.1063 18.9576 12.5215 18.7085 12.8194L14.863 17.4179V20.021C14.863 20.3998 14.649 20.746 14.3102 20.9154L11.8004 22.1703C11.4904 22.3253 11.1223 22.3088 10.8274 22.1265C10.5326 21.9443 10.3532 21.6225 10.3532 21.2759V17.4179L6.50763 12.8194C6.25851 12.5215 6.20438 12.1063 6.36879 11.7545ZM9.41459 13.1779L12.1203 16.4134C12.2707 16.5933 12.3532 16.8203 12.3532 17.0549V19.6579L12.863 19.403V17.0549C12.863 16.8203 12.9454 16.5933 13.0959 16.4134L15.8016 13.1779H9.41459Z"
        fill="#219653"
      />
      <path
        d="M10.0002 9.62883C10.0002 10.1811 9.55252 10.6288 9.00024 10.6288C8.44795 10.6288 8.00024 10.1811 8.00024 9.62883C8.00024 9.07655 8.44795 8.62883 9.00024 8.62883C9.55252 8.62883 10.0002 9.07655 10.0002 9.62883Z"
        fill="#219653"
      />
      <path
        d="M13.137 9.62883C13.137 10.1811 12.6892 10.6288 12.137 10.6288C11.5847 10.6288 11.137 10.1811 11.137 9.62883C11.137 9.07655 11.5847 8.62883 12.137 8.62883C12.6892 8.62883 13.137 9.07655 13.137 9.62883Z"
        fill="#219653"
      />
      <path
        d="M14.0002 23.6288C14.0002 24.1811 13.5525 24.6288 13.0002 24.6288C12.448 24.6288 12.0002 24.1811 12.0002 23.6288C12.0002 23.0765 12.448 22.6288 13.0002 22.6288C13.5525 22.6288 14.0002 23.0765 14.0002 23.6288Z"
        fill="#219653"
      />
      <path
        d="M16.2737 9.62883C16.2737 10.1811 15.826 10.6288 15.2737 10.6288C14.7214 10.6288 14.2737 10.1811 14.2737 9.62883C14.2737 9.07655 14.7214 8.62883 15.2737 8.62883C15.826 8.62883 16.2737 9.07655 16.2737 9.62883Z"
        fill="#219653"
      />
      <path
        d="M30.6478 0.753038C30.6478 0.635164 30.601 0.522118 30.5176 0.438768C30.4343 0.355419 30.3212 0.308594 30.2034 0.308594C30.0855 0.308594 29.9724 0.355419 29.8891 0.438768C29.8057 0.522118 29.7589 0.635164 29.7589 0.753038C29.7589 1.39482 29.6705 2.29793 29.2425 3.02815C28.8363 3.72015 28.0967 4.30859 26.6478 4.30859C26.5299 4.30859 26.4169 4.35542 26.3335 4.43877C26.2502 4.52212 26.2034 4.63516 26.2034 4.75304C26.2034 4.87091 26.2502 4.98396 26.3335 5.06731C26.4169 5.15066 26.5299 5.19748 26.6478 5.19748C27.238 5.19748 28.0176 5.37659 28.6416 5.89526C29.2487 6.39882 29.7589 7.26637 29.7589 8.75304C29.7589 8.87091 29.8057 8.98396 29.8891 9.06731C29.9724 9.15066 30.0855 9.19748 30.2034 9.19748C30.3212 9.19748 30.4343 9.15066 30.5176 9.06731C30.601 8.98396 30.6478 8.87091 30.6478 8.75304C30.6478 8.11126 30.7363 7.20815 31.1643 6.47793C31.5705 5.78593 32.31 5.19748 33.7589 5.19748C33.8768 5.19748 33.9898 5.15066 34.0732 5.06731C34.1565 4.98396 34.2034 4.87091 34.2034 4.75304C34.2034 4.63516 34.1565 4.52212 34.0732 4.43877C33.9898 4.35542 33.8768 4.30859 33.7589 4.30859C33.1687 4.30859 32.3891 4.12948 31.7651 3.61082C31.158 3.10726 30.6478 2.2397 30.6478 0.753038ZM30.0087 3.47793C30.0918 3.33659 30.1643 3.19126 30.2278 3.04459C30.4566 3.52657 30.7874 3.95313 31.1971 4.29482C31.3945 4.45882 31.602 4.59615 31.814 4.70993C31.1718 5.02104 30.7136 5.48948 30.398 6.02815C30.3161 6.16793 30.2429 6.31265 30.1789 6.46148C29.9501 5.97952 29.6193 5.55296 29.2096 5.21126C29.0183 5.05268 28.8116 4.91362 28.5927 4.79615C29.2349 4.48504 29.6927 4.01659 30.0087 3.47793Z"
        fill="#219653"
      />
    </svg>
  );
};

export const TempratureIcon2 = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="1 0 26 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 17.3086C14.7614 17.3086 17 15.07 17 12.3086C17 9.54717 14.7614 7.30859 12 7.30859C9.23858 7.30859 7 9.54717 7 12.3086C7 15.07 9.23858 17.3086 12 17.3086Z"
        stroke="#49B8EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 1.30859V3.30859"
        stroke="#49B8EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1016 9.97559V11.9756"
        stroke="#49B8EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5703 13.333L12.1011 11.9761"
        stroke="#49B8EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 21.3086V23.3086"
        stroke="#49B8EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.21875 4.52832L5.63875 5.94832"
        stroke="#49B8EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3594 18.6689L19.7794 20.0889"
        stroke="#49B8EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 12.3086H3"
        stroke="#49B8EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12.3086H23"
        stroke="#49B8EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.21875 20.0889L5.63875 18.6689"
        stroke="#49B8EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3594 5.94832L19.7794 4.52832"
        stroke="#49B8EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TempratureIcon3 = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 17 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.72573 6.08286H10.7733C10.7733 6.08271 10.7733 6.08256 10.7733 6.0824C10.7733 4.13626 9.19569 2.55859 7.24954 2.55859C5.30339 2.55859 3.72573 4.13626 3.72573 6.0824C3.72573 6.08256 3.72573 6.08271 3.72573 6.08286ZM1.72576 6.10151C1.72574 6.09514 1.72573 6.08877 1.72573 6.0824C1.72573 3.03169 4.19882 0.558594 7.24954 0.558594C10.3003 0.558594 12.7733 3.03169 12.7733 6.0824C12.7733 6.08873 12.7733 6.09506 12.7733 6.10138C13.7486 6.23466 14.5 7.07101 14.5 8.08286V18.5829C14.5 19.6874 13.6046 20.5829 12.5 20.5829H2C0.895431 20.5829 0 19.6874 0 18.5829V8.08286C0 7.07132 0.750947 6.23518 1.72576 6.10151ZM7.21368 11.6061C6.27874 11.6173 5.52427 12.3786 5.52427 13.3162C5.52427 14.0283 5.95946 14.6388 6.57837 14.8961V17.1527H7.8988V14.8927C8.51341 14.6334 8.9448 14.0252 8.9448 13.3162C8.9448 12.381 8.19414 11.6211 7.26247 11.6062C7.25816 11.6062 7.25385 11.6062 7.24954 11.6062C7.23758 11.6062 7.22563 11.6062 7.21368 11.6061Z"
        fill="#BDBDBD"
      />
    </svg>
  );
};
export const PlayerNext = () => {
  return (
    <svg
      width="40"
      height="25"
      viewBox="0 0 40 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8352 1.8125L37.9595 12.2631L21.8352 22.7137L21.8352 1.8125Z"
        fill="#49B8EF"
      />
      <path
        d="M2.12891 1.8125L18.2532 12.2631L2.12891 22.7137L2.12891 1.8125Z"
        fill="#49B8EF"
      />
      <path
        d="M21.8352 1.8125L37.9595 12.2631L21.8352 22.7137L21.8352 1.8125Z"
        stroke="#49B8EF"
        strokeWidth="2.98588"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.12891 1.8125L18.2532 12.2631L2.12891 22.7137L2.12891 1.8125Z"
        stroke="#49B8EF"
        strokeWidth="2.98588"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PlayerPrevious = () => {
  return (
    <svg
      width="40"
      height="25"
      viewBox="0 0 40 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5114 22.7137L2.38281 12.2631L18.5114 1.8125V22.7137Z"
        fill="#49B8EF"
      />
      <path
        d="M38.2134 22.7137L22.0848 12.2631L38.2134 1.8125V22.7137Z"
        fill="#49B8EF"
      />
      <path
        d="M18.5114 22.7137L2.38281 12.2631L18.5114 1.8125V22.7137Z"
        stroke="#49B8EF"
        strokeWidth="2.98588"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.2134 22.7137L22.0848 12.2631L38.2134 1.8125V22.7137Z"
        stroke="#49B8EF"
        strokeWidth="2.98588"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PumpOne = () => {
  return (
    <svg
      width="23"
      height="18"
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.03942 15.6399H2.63017C1.29921 15.6399 0.203125 14.6071 0.203125 13.353V4.94314C0.203125 3.68904 1.29921 2.65625 2.63017 2.65625H4.11772C5.37038 2.65625 6.46647 3.68904 6.46647 4.94314V13.4267C6.46647 14.6071 5.37038 15.6399 4.03942 15.6399ZM2.63017 3.83658C2.00384 3.83658 1.45579 4.35297 1.45579 4.94314V13.4267C1.45579 14.0169 2.00384 14.5333 2.63017 14.5333H4.11772C4.74405 14.5333 5.29209 14.0169 5.29209 13.4267V4.94314C5.29209 4.35297 4.74405 3.83658 4.11772 3.83658H2.63017Z"
        fill="#3699FF"
      />
      <path
        d="M8.73798 18.0018H7.95506C6.46751 18.0018 5.21484 16.8215 5.21484 15.4198V2.87884C5.21484 1.4772 6.46751 0.296875 7.95506 0.296875H8.73798C10.2255 0.296875 11.4782 1.4772 11.4782 2.87884V15.4198C11.4782 16.8952 10.2255 18.0018 8.73798 18.0018ZM7.95506 1.4772C7.09385 1.4772 6.46751 2.14114 6.46751 2.87884V15.4198C6.46751 16.1575 7.09385 16.8215 7.95506 16.8215H8.73798C9.52089 16.8215 10.2255 16.2313 10.2255 15.4198V2.87884C10.2255 2.14114 9.59918 1.4772 8.73798 1.4772H7.95506Z"
        fill="#3699FF"
      />
      <path
        d="M12.5751 6.63981C12.2619 6.63981 12.0271 6.4185 11.9488 6.19719C11.8705 5.9021 12.1054 5.53325 12.4185 5.53325L16.3331 4.79555C16.6463 4.72178 17.0377 4.94309 17.0377 5.23817C17.116 5.53325 16.8812 5.90211 16.568 5.90211L12.6534 6.63981H12.5751Z"
        fill="#3699FF"
      />
      <path
        d="M13.2006 9.81314C12.8874 9.81314 12.5742 9.51806 12.5742 9.22298C12.5742 8.92789 12.8874 8.63281 13.2006 8.63281H19.5422C19.8554 8.63281 20.1685 8.92789 20.1685 9.22298C20.1685 9.51806 19.8554 9.81314 19.5422 9.81314H13.2006Z"
        fill="#3699FF"
      />
      <path
        d="M16.8777 13.5756H16.7994L12.4934 13.0592C12.1802 12.9855 11.9453 12.6904 11.9453 12.3953C12.0236 12.1002 12.2585 11.8789 12.6499 11.8789L16.956 12.3953C17.2692 12.4691 17.504 12.7642 17.504 13.0592C17.4257 13.3543 17.1909 13.5756 16.8777 13.5756Z"
        fill="#3699FF"
      />
      <path
        d="M22.2027 3.68852H21.5764V0.737705L20.5586 1.03279V0.516393L22.1244 0H22.2027V3.68852Z"
        fill="#3699FF"
      />
    </svg>
  );
};
export const PumpTwo = () => {
  return (
    <svg
      width="23"
      height="18"
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.89491 15.5984H2.53874C1.25792 15.5984 0.203125 14.5484 0.203125 13.2734V4.72344C0.203125 3.44844 1.25792 2.39844 2.53874 2.39844H3.97025C5.17573 2.39844 6.23052 3.44844 6.23052 4.72344V13.3484C6.23052 14.5484 5.17573 15.5984 3.89491 15.5984ZM2.53874 3.59844C1.936 3.59844 1.4086 4.12344 1.4086 4.72344V13.3484C1.4086 13.9484 1.936 14.4734 2.53874 14.4734H3.97025C4.57299 14.4734 5.10039 13.9484 5.10039 13.3484V4.72344C5.10039 4.12344 4.57299 3.59844 3.97025 3.59844H2.53874Z"
        fill="#3699FF"
      />
      <path
        d="M8.41385 18H7.66042C6.22892 18 5.02344 16.8 5.02344 15.375V2.625C5.02344 1.2 6.22892 0 7.66042 0H8.41385C9.84536 0 11.0508 1.2 11.0508 2.625V15.375C11.0508 16.8 9.84536 18 8.41385 18ZM7.66042 1.2C6.83166 1.2 6.22892 1.8 6.22892 2.625V15.375C6.22892 16.125 6.83166 16.8 7.66042 16.8H8.41385C9.16727 16.8 9.84536 16.2 9.84536 15.375V2.625C9.84536 1.875 9.24262 1.2 8.41385 1.2H7.66042Z"
        fill="#3699FF"
      />
      <path
        d="M12.1056 6.44844C11.8043 6.44844 11.5782 6.22344 11.5029 5.99844C11.4275 5.69844 11.6536 5.32344 11.9549 5.32344L15.7221 4.57344C16.0234 4.49844 16.4001 4.64844 16.4755 5.02344C16.5508 5.32344 16.3248 5.69844 16.0234 5.69844L12.2563 6.44844C12.181 6.44844 12.1056 6.44844 12.1056 6.44844Z"
        fill="#3699FF"
      />
      <path
        d="M12.7082 9.67656C12.4068 9.67656 12.1055 9.37656 12.1055 9.07656C12.1055 8.77656 12.4068 8.47656 12.7082 8.47656H18.8109C19.1123 8.47656 19.4137 8.77656 19.4137 9.07656C19.4137 9.37656 19.1123 9.67656 18.8109 9.67656H12.7082Z"
        fill="#3699FF"
      />
      <path
        d="M16.2505 13.4984H16.1751L12.0313 12.9734C11.7299 12.8984 11.5039 12.5984 11.5039 12.2984C11.5792 11.9984 11.8053 11.7734 12.182 11.7734L16.3258 12.2984C16.6272 12.3734 16.8532 12.6734 16.8532 12.9734C16.7779 13.2734 16.5519 13.4984 16.2505 13.4984Z"
        fill="#3699FF"
      />
      <path
        d="M22.2011 17.9266H19.7148V17.4766L20.9957 16.1266C21.1464 15.9016 21.297 15.7516 21.3724 15.6016C21.4477 15.4516 21.5231 15.3016 21.5231 15.2266C21.5231 15.0766 21.4477 14.9266 21.3724 14.7766C21.297 14.7016 21.1464 14.6266 20.9957 14.6266C20.7696 14.6266 20.619 14.7016 20.5436 14.7766C20.4683 14.9266 20.3929 15.0766 20.3929 15.3016H19.7902C19.7902 15.0766 19.8655 14.8516 19.9409 14.7016C20.0162 14.5516 20.1669 14.4016 20.3929 14.2516C20.619 14.1766 20.845 14.1016 21.071 14.1016C21.4477 14.1016 21.7491 14.1766 21.8998 14.4016C22.1258 14.5516 22.2011 14.8516 22.2011 15.1516C22.2011 15.3016 22.1258 15.5266 22.0505 15.7516C21.9751 15.9766 21.7491 16.2016 21.5231 16.4266L20.619 17.4016H22.3518V17.9266H22.2011Z"
        fill="#3699FF"
      />
    </svg>
  );
};
export const Blower = () => {
  return (
    <svg
      width="23"
      height="18"
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.13743 15.6H2.69218C1.32721 15.6 0.203125 14.55 0.203125 13.275V4.725C0.203125 3.45 1.32721 2.4 2.69218 2.4H4.21772C5.58269 2.4 6.70678 3.45 6.70678 4.725V13.35C6.62648 14.55 5.5024 15.6 4.13743 15.6ZM2.69218 3.6C2.04984 3.6 1.4878 4.125 1.4878 4.725V13.35C1.4878 13.95 2.04984 14.475 2.69218 14.475H4.21772C4.86006 14.475 5.4221 13.95 5.4221 13.35V4.725C5.4221 4.125 4.86006 3.6 4.21772 3.6H2.69218Z"
        fill="#3699FF"
      />
      <path
        d="M8.95495 18H8.15203C6.62648 18 5.34181 16.8 5.34181 15.375V2.625C5.34181 1.2 6.62648 0 8.15203 0H8.95495C10.4805 0 11.7652 1.2 11.7652 2.625V15.375C11.7652 16.8 10.4805 18 8.95495 18ZM8.15203 1.2C7.34911 1.2 6.62648 1.8 6.62648 2.625V15.375C6.62648 16.125 7.26882 16.8 8.15203 16.8H8.95495C9.75787 16.8 10.4805 16.2 10.4805 15.375V2.625C10.4805 1.875 9.83816 1.2 8.95495 1.2H8.15203Z"
        fill="#3699FF"
      />
      <path
        d="M16.5024 8.85C14.6557 8.85 13.1301 7.5 13.1301 5.775C13.1301 4.05 14.6557 2.7 16.5024 2.7C18.3491 2.7 19.8747 4.05 19.8747 5.775C19.8747 7.5 18.3491 8.85 16.5024 8.85ZM16.5024 3.6C15.1374 3.6 14.0936 4.575 14.0936 5.775C14.0936 6.975 15.1374 7.95 16.5024 7.95C17.8674 7.95 18.9112 6.975 18.9112 5.775C18.9112 4.575 17.8674 3.6 16.5024 3.6Z"
        fill="#3699FF"
      />
      <path
        d="M20.6776 10.575C19.8747 10.575 19.152 9.975 19.152 9.15C19.152 8.4 19.7944 7.725 20.6776 7.725C21.4805 7.725 22.2031 8.325 22.2031 9.15C22.2031 9.975 21.4805 10.575 20.6776 10.575ZM20.6776 8.625C20.3564 8.625 20.1155 8.85 20.1155 9.15C20.1155 9.45 20.3564 9.675 20.6776 9.675C20.9987 9.675 21.2396 9.45 21.2396 9.15C21.2396 8.85 20.9987 8.625 20.6776 8.625Z"
        fill="#3699FF"
      />
      <path
        d="M14.8163 13.35C13.7725 13.35 12.8893 12.525 12.8893 11.55C12.8893 10.575 13.7725 9.75 14.8163 9.75C15.8601 9.75 16.7433 10.575 16.7433 11.55C16.7433 12.525 15.9404 13.35 14.8163 13.35ZM14.8163 10.725C14.2542 10.725 13.8528 11.1 13.8528 11.625C13.8528 12.075 14.2542 12.525 14.8163 12.525C15.3783 12.525 15.7798 12.15 15.7798 11.625C15.7798 11.1 15.3783 10.725 14.8163 10.725Z"
        fill="#3699FF"
      />
    </svg>
  );
};

export const Addjust = () => {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4.41406" cy="4" r="4" fill="#F2C94C" />
    </svg>
  );
};

export const Increment = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="53"
      height="43"
      viewBox="0 0 53 43"
      fill="#000"	
    >
      <g filter="url(#filter0_d_7124_51009)">
        <rect
          x="49.4688"
          y="36.75"
          width="46.2216"
          height="35.7844"
          rx="7.45509"
          transform="rotate(180 49.4688 36.75)"
          fill={props.style?.color}
          {...props}
        />
      </g>
      <path
        d="M33.7524 17.1332C35.0198 17.1332 36.0473 18.1606 36.0473 19.4281C36.0473 20.6955 35.0198 21.723 33.7524 21.723H18.959C17.6915 21.723 16.6641 20.6955 16.6641 19.4281C16.6641 18.1606 17.6915 17.1332 18.959 17.1332H33.7524ZM26.3654 9.91016C27.8296 9.91016 29.0165 11.0971 29.0165 12.5613V26.6423C29.0165 28.1064 27.8296 29.2934 26.3654 29.2934C24.9012 29.2934 23.7143 28.1064 23.7143 26.6423V12.5613C23.7143 11.0971 24.9012 9.91016 26.3654 9.91016Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_7124_51009"
          x="0.264058"
          y="0.964844"
          width="52.1867"
          height="41.7492"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.98204" />
          <feGaussianBlur stdDeviation="1.49102" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.286275 0 0 0 0 0.721569 0 0 0 0 0.937255 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7124_51009"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7124_51009"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const Decrement = props => {
  return (
    <svg
      width="53"
      height="43"
      viewBox="0 0 53 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_7124_51006)">
        <rect
          x="3.35938"
          y="0.964844"
          width="46.2216"
          height="35.7844"
          rx="7.45509"
          fill={props.style?.color}
          {...props}
        />
      </g>
      <path
        d="M33.9268 17.3672C35.162 17.3672 36.1633 18.3685 36.1633 19.6037C36.1633 20.8389 35.162 21.8402 33.9268 21.8402H17.5256C16.2904 21.8402 15.2891 20.8389 15.2891 19.6037C15.2891 18.3685 16.2904 17.3672 17.5256 17.3672H33.9268Z"
        fill="#F2F2F2"
      />
      <defs>
        <filter
          id="filter0_d_7124_51006"
          x="0.377339"
          y="0.964844"
          width="52.1867"
          height="41.7492"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.98204" />
          <feGaussianBlur stdDeviation="1.49102" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.286275 0 0 0 0 0.721569 0 0 0 0 0.937255 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7124_51006"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7124_51006"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const WaterTreatmentReplace = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.1832 23.4673C48.2276 23.4673 49.0743 24.314 49.0743 25.3585C49.0743 39.9551 38.3054 49.7953 25.0754 49.7953C14.478 49.7953 5.65306 44.1369 2.55599 34.9829C2.22126 33.9935 2.75193 32.9201 3.74127 32.5854C4.73062 32.2506 5.804 32.7813 6.13873 33.7707C8.63285 41.1426 15.824 46.013 25.0754 46.013C36.2663 46.013 45.292 37.8167 45.292 25.3585C45.292 24.314 46.1387 23.4673 47.1832 23.4673Z"
        fill="#3699FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.2025 4.70421C13.0116 4.70421 3.98582 12.9005 3.98582 25.3587C3.98582 26.4032 3.13913 27.2499 2.0947 27.2499C1.05026 27.2499 0.203572 26.4032 0.203572 25.3587C0.203572 10.7621 10.9725 0.921875 24.2025 0.921875C34.8022 0.921875 43.6248 6.58037 46.7219 15.7343C47.0566 16.7237 46.5259 17.7971 45.5366 18.1319C44.5472 18.4666 43.4738 17.9359 43.1391 16.9465C40.645 9.57453 33.456 4.70421 24.2025 4.70421Z"
        fill="#3699FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.51455 33.9187C2.76787 32.9054 3.79462 32.2893 4.80788 32.5426L13.8259 34.7972C14.8392 35.0505 15.4552 36.0773 15.2019 37.0906C14.9486 38.1038 13.9219 38.7199 12.9086 38.4666L5.72521 36.6707L3.92936 43.8543C3.67604 44.8675 2.64928 45.4836 1.63603 45.2303C0.622776 44.977 0.00672284 43.9502 0.260037 42.9369L2.51455 33.9187Z"
        fill="#3699FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.6437 5.48791C48.6569 5.74123 49.273 6.76801 49.0197 7.78129L46.7652 16.7996C46.5119 17.8128 45.4851 18.4289 44.4718 18.1756L35.4538 15.921C34.4405 15.6677 33.8245 14.6409 34.0778 13.6276C34.3311 12.6144 35.3578 11.9983 36.3711 12.2516L43.5545 14.0475L45.3504 6.86394C45.6037 5.85066 46.6304 5.23459 47.6437 5.48791Z"
        fill="#3699FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.2473 19.8117C12.5582 19.1463 13.2262 18.7212 13.9606 18.7212H34.1326C34.8669 18.7212 35.5349 19.1463 35.8458 19.8117C36.1567 20.477 36.0544 21.2622 35.5833 21.8255L28.3109 30.5221V35.445C28.3109 36.1613 27.9062 36.8162 27.2655 37.1365L22.5191 39.5098C21.9329 39.8029 21.2367 39.7716 20.6792 39.427C20.1216 39.0824 19.7823 38.4737 19.7823 37.8183V30.5221L12.5099 21.8255C12.0387 21.2622 11.9364 20.477 12.2473 19.8117ZM18.0073 22.5035L23.1241 28.6224C23.4086 28.9626 23.5645 29.392 23.5645 29.8356V34.7583L24.5286 34.2762V29.8356C24.5286 29.392 24.6845 28.9626 24.969 28.6224L30.0859 22.5035H18.0073Z"
        fill="#3699FF"
      />
      <path
        d="M19.1148 15.7917C19.1148 16.8362 18.2681 17.6829 17.2237 17.6829C16.1792 17.6829 15.3326 16.8362 15.3326 15.7917C15.3326 14.7473 16.1792 13.9006 17.2237 13.9006C18.2681 13.9006 19.1148 14.7473 19.1148 15.7917Z"
        fill="#3699FF"
      />
      <path
        d="M25.0467 15.7917C25.0467 16.8362 24.2 17.6829 23.1556 17.6829C22.1112 17.6829 21.2645 16.8362 21.2645 15.7917C21.2645 14.7473 22.1112 13.9006 23.1556 13.9006C24.2 13.9006 25.0467 14.7473 25.0467 15.7917Z"
        fill="#3699FF"
      />
      <path
        d="M26.6793 42.2681C26.6793 43.3125 25.8326 44.1592 24.7882 44.1592C23.7437 44.1592 22.8971 43.3125 22.8971 42.2681C22.8971 41.2236 23.7437 40.3769 24.7882 40.3769C25.8326 40.3769 26.6793 41.2236 26.6793 42.2681Z"
        fill="#3699FF"
      />
      <path
        d="M30.9787 15.7917C30.9787 16.8362 30.132 17.6829 29.0875 17.6829C28.0431 17.6829 27.1964 16.8362 27.1964 15.7917C27.1964 14.7473 28.0431 13.9006 29.0875 13.9006C30.132 13.9006 30.9787 14.7473 30.9787 15.7917Z"
        fill="#3699FF"
      />
    </svg>
  );
};

export const WaterTreatmentTest = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M46.9967 22.5455C48.0412 22.5455 48.8879 23.3922 48.8879 24.4366C48.8879 39.0332 38.1188 48.8735 24.8884 48.8735C14.2908 48.8735 5.46569 43.2151 2.36854 34.061C2.0338 33.0716 2.56449 31.9982 3.55385 31.6635C4.54322 31.3288 5.61663 31.8594 5.95137 32.8488C8.44555 40.2207 15.6369 45.0911 24.8884 45.0911C36.0796 45.0911 45.1056 36.8949 45.1056 24.4366C45.1056 23.3922 45.9523 22.5455 46.9967 22.5455Z"
        fill="#3699FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.0155 3.78233C12.8244 3.78233 3.79841 11.9786 3.79841 24.4368C3.79841 25.4813 2.9517 26.328 1.90724 26.328C0.862777 26.328 0.0160723 25.4813 0.0160723 24.4368C0.0160723 9.84027 10.7852 0 24.0155 0C34.6155 0 43.4383 5.6585 46.5354 14.8125C46.8702 15.8018 46.3395 16.8752 45.3501 17.21C44.3607 17.5447 43.2873 17.014 42.9526 16.0247C40.4584 8.65266 33.2692 3.78233 24.0155 3.78233Z"
        fill="#3699FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.32711 32.9968C2.58042 31.9835 3.6072 31.3674 4.62048 31.6208L13.6388 33.8753C14.652 34.1286 15.2681 35.1554 15.0148 36.1687C14.7615 37.182 13.7347 37.798 12.7214 37.5447L5.53783 35.7488L3.74194 42.9324C3.48862 43.9457 2.46184 44.5617 1.44856 44.3084C0.435286 44.0551 -0.180782 43.0283 0.072538 42.015L2.32711 32.9968Z"
        fill="#3699FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M47.4573 4.56604C48.4706 4.81936 49.0866 5.84614 48.8333 6.85941L46.5787 15.8777C46.3254 16.891 45.2986 17.507 44.2854 17.2537L35.2671 14.9991C34.2538 14.7458 33.6377 13.719 33.8911 12.7058C34.1444 11.6925 35.1712 11.0764 36.1844 11.3297L43.368 13.1256L45.1639 5.94206C45.4172 4.92879 46.444 4.31272 47.4573 4.56604Z"
        fill="#3699FF"
      />
      <path
        d="M16.4659 34.1189C15.7171 34.1189 15.2057 33.7423 14.9317 32.9892C14.6578 32.2362 14.7308 31.6265 15.1509 31.1603L21.9452 23.6295V16.3677H20.5206C20.3014 16.3677 20.1097 16.287 19.9453 16.1256C19.7809 15.9642 19.6987 15.7759 19.6987 15.5608C19.6987 15.3456 19.7809 15.1573 19.9453 14.996C20.1097 14.8346 20.3014 14.7539 20.5206 14.7539H29.2874C29.5066 14.7539 29.6984 14.8346 29.8628 14.996C30.0271 15.1573 30.1093 15.3456 30.1093 15.5608C30.1093 15.7759 30.0271 15.9642 29.8628 16.1256C29.6984 16.287 29.5066 16.3677 29.2874 16.3677H27.8628V23.6295L34.6571 31.1603C35.0955 31.6445 35.1731 32.2586 34.89 33.0027C34.6069 33.7468 34.0909 34.1189 33.3421 34.1189H16.4659ZM16.1372 32.5051H33.6709L26.219 24.2212V16.3677H23.589V24.2212L16.1372 32.5051Z"
        fill="#3699FF"
      />
      <rect
        x="23.0703"
        y="15.6758"
        width="3.68856"
        height="17.5207"
        fill="#3699FF"
      />
      <rect
        x="22.875"
        y="27.2773"
        width="5.14376"
        height="8.92236"
        transform="rotate(-39.9281 22.875 27.2773)"
        fill="#3699FF"
      />
      <rect
        x="23.8594"
        y="23.9766"
        width="5.14376"
        height="8.92236"
        transform="rotate(45.1368 23.8594 23.9766)"
        fill="#3699FF"
      />
      <rect
        x="33.7812"
        y="30.7969"
        width="2.46715"
        height="17.6769"
        transform="rotate(90.6934 33.7812 30.7969)"
        fill="#3699FF"
      />
    </svg>
  );
};

export const WaterTreatmentReplaced = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="49"
      viewBox="0 0 50 49"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.61091 24.4368C4.61091 11.9786 13.6369 3.78233 24.828 3.78233C32.5716 3.78233 38.8694 7.19272 42.1803 12.6256L36.9969 11.3297C35.9837 11.0764 34.9569 11.6925 34.7036 12.7058C34.4502 13.719 35.0663 14.7458 36.0796 14.9991L45.0979 17.2537C46.0877 17.5012 47.0905 16.9189 47.3725 15.9472C47.3813 15.917 47.3894 15.8865 47.3967 15.8559L49.6458 6.85941C49.8991 5.84614 49.2831 4.81936 48.2698 4.56604C47.2565 4.31272 46.2297 4.92879 45.9764 5.94206L44.9716 9.96108C40.8127 3.70189 33.4017 0 24.828 0C11.5977 0 0.828572 9.84027 0.828572 24.4368C0.828572 25.4813 1.67528 26.328 2.71974 26.328C3.7642 26.328 4.61091 25.4813 4.61091 24.4368ZM49.7004 24.4366C49.7004 23.3922 48.8537 22.5455 47.8092 22.5455C46.7648 22.5455 45.9181 23.3922 45.9181 24.4366C45.9181 36.8949 36.8921 45.0911 25.7009 45.0911C17.9595 45.0911 11.6607 41.681 8.34926 36.2486L13.5339 37.5447C14.5472 37.798 15.574 37.182 15.8273 36.1687C16.0806 35.1554 15.4645 34.1286 14.4513 33.8753L5.46311 31.6283C5.11414 31.5342 4.73443 31.539 4.36635 31.6635C3.7026 31.8881 3.24529 32.4451 3.11726 33.0862L0.885038 42.015C0.631718 43.0283 1.24779 44.0551 2.26106 44.3084C3.27434 44.5617 4.30112 43.9457 4.55444 42.9324L5.55892 38.9145C9.71867 45.1725 17.1301 48.8735 25.7009 48.8735C38.9313 48.8735 49.7004 39.0332 49.7004 24.4366ZM32.0723 27.6065C32.0723 31.6749 28.941 34.9735 25.0775 34.9735C21.2141 34.9735 18.0828 31.6749 18.0828 27.6065C18.0828 27.5813 18.0829 27.5561 18.0831 27.5309C18.1232 22.7847 21.9164 17.4115 23.8993 14.924C24.6017 14.0417 25.0775 13.523 25.0775 13.523C25.0782 13.5237 25.1382 13.5893 25.2468 13.713C26.2653 14.8732 31.5525 21.1428 32.0367 26.794C32.0601 27.0665 32.0723 27.3375 32.0723 27.6065Z"
        fill="#3699FF"
      />
    </svg>
  );
};

export const MusicIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.0004 1.2422C17.0004 0.937576 16.8616 0.649567 16.6233 0.45984C16.385 0.270113 16.0731 0.19936 15.7763 0.267645L5.34142 2.66785C4.88736 2.77229 4.56559 3.17648 4.56559 3.6424V11.2898C4.16588 11.1292 3.73039 11.0416 3.28266 11.0416C1.54976 11.0416 0 12.3529 0 14.1419C0 15.9309 1.54976 17.2421 3.28266 17.2421C5.00586 17.2421 6.54794 15.9455 6.56518 14.1719C6.56545 14.1624 6.56559 14.1529 6.56559 14.1433V4.43849L15.0004 2.49833V8.89008C14.6008 8.72941 14.1653 8.6419 13.7176 8.6419C11.9847 8.6419 10.4349 9.95312 10.4349 11.7421C10.4349 13.5311 11.9847 14.8423 13.7176 14.8423C15.4423 14.8423 16.9856 13.5435 17.0002 11.7674C17.0003 11.7593 17.0004 11.7512 17.0004 11.7431V1.2422ZM13.7176 10.6419C12.9291 10.6419 12.4349 11.2113 12.4349 11.7421C12.4349 12.273 12.9291 12.8423 13.7176 12.8423C14.506 12.8423 15.0003 12.273 15.0003 11.7421C15.0003 11.2113 14.506 10.6419 13.7176 10.6419ZM3.28266 13.0416C2.49421 13.0416 2 13.611 2 14.1419C2 14.6727 2.49421 15.2421 3.28266 15.2421C4.07112 15.2421 4.56533 14.6727 4.56533 14.1419C4.56533 13.611 4.07112 13.0416 3.28266 13.0416Z"
        fill="#3699FF"
      />
    </svg>
  );
};

export const LightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.62988 3.32513C8.78615 2.75627 7.77962 2.46181 6.7532 2.48572L6.75254 2.48574C4.10126 2.54579 1.98799 4.71424 2.00005 7.28633L2.00006 7.28769C2.00244 8.00308 2.1704 8.70922 2.49201 9.35278C2.81366 9.99641 3.28091 10.5612 3.85961 11.0035L3.25238 11.798L3.86462 11.0074C4.19382 11.2623 4.46184 11.5879 4.6476 11.9609C4.83338 12.334 4.93176 12.7443 4.93466 13.1612L4.9347 13.1682H4.93468V13.1777H8.80392V13.1682L8.80392 13.1662C8.80475 12.7448 8.90363 12.3299 9.0922 11.9532C9.28009 11.578 9.55171 11.2513 9.88516 10.9972C10.6878 10.3769 11.2689 9.52647 11.5495 8.56801C11.8305 7.60872 11.797 6.58714 11.4537 5.64719C11.1104 4.70702 10.4734 3.89382 9.62988 3.32513ZM2.642 12.5901C1.82467 11.9647 1.1612 11.1638 0.702971 10.2468C0.244121 9.32864 0.00348053 8.31893 6.79218e-05 7.29435L1.00006 7.29102L7.33458e-05 7.29571L6.79218e-05 7.29435C-0.0164738 3.60794 2.99053 0.570776 6.70661 0.486267L6.72989 1.48563L6.70726 0.486252C8.1452 0.452882 9.55885 0.865141 10.7479 1.66682C11.9374 2.46878 12.8428 3.62058 13.3324 4.96106C13.822 6.30177 13.8699 7.76074 13.4689 9.13007C13.068 10.4992 12.2396 11.7065 11.1045 12.5825L11.0985 12.5871L11.0985 12.5871C11.0052 12.658 10.9311 12.7478 10.8806 12.8487C10.8302 12.9493 10.8042 13.0589 10.8039 13.1694V13.6008C10.8039 14.0247 10.6325 14.4276 10.333 14.7219C10.0341 15.0157 9.63236 15.1777 9.21699 15.1777H4.5216C4.10623 15.1777 3.70448 15.0157 3.4056 14.7219C3.10613 14.4276 2.93468 14.0247 2.93468 13.6008V13.1724C2.9335 13.0621 2.90732 12.9529 2.8573 12.8524C2.80716 12.7517 2.73401 12.6618 2.642 12.5901ZM2.93652 16.4844C2.93652 15.9321 3.38424 15.4844 3.93652 15.4844H9.80788C10.3602 15.4844 10.8079 15.9321 10.8079 16.4844C10.8079 17.0367 10.3602 17.4844 9.80788 17.4844H3.93652C3.38424 17.4844 2.93652 17.0367 2.93652 16.4844ZM7.62822 2.86492C7.08345 2.77415 6.56824 3.14219 6.47747 3.68696C6.38669 4.23174 6.75474 4.74695 7.29951 4.83772C7.8166 4.92388 8.29126 5.16531 8.65889 5.52574C9.02631 5.88596 9.26874 6.34708 9.35585 6.84446C9.45113 7.38846 9.96936 7.75223 10.5134 7.65695C11.0574 7.56168 11.4211 7.04344 11.3259 6.49944C11.166 5.58672 10.7223 4.74785 10.059 4.09761C9.39603 3.44758 8.54636 3.0179 7.62822 2.86492Z"
        fill="#3699FF"
      />
    </svg>
  );
};

export const ScienceFillo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
    >
      <path
        d="M10.03 49C8.43559 49 7.3467 48.1833 6.76336 46.55C6.18003 44.9167 6.33559 43.5944 7.23003 42.5833L21.6967 26.25V10.5H18.6634C18.1967 10.5 17.7884 10.325 17.4384 9.975C17.0884 9.625 16.9134 9.21667 16.9134 8.75C16.9134 8.28333 17.0884 7.875 17.4384 7.525C17.7884 7.175 18.1967 7 18.6634 7H37.33C37.7967 7 38.205 7.175 38.555 7.525C38.905 7.875 39.08 8.28333 39.08 8.75C39.08 9.21667 38.905 9.625 38.555 9.975C38.205 10.325 37.7967 10.5 37.33 10.5H34.2967V26.25L48.7634 42.5833C49.6967 43.6333 49.862 44.9653 49.2592 46.5792C48.6564 48.1931 47.5578 49 45.9634 49H10.03ZM9.33003 45.5H46.6634L30.7967 27.5333V10.5H25.1967V27.5333L9.33003 45.5Z"
        fill="#3699FF"
      />
    </svg>
  );
};

export const CalenderIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        opacity="0.3"
        d="M2.83203 9.07787V13.8195C2.83203 15.0174 3.30789 16.1663 4.15493 17.0133C5.00197 17.8603 6.1508 18.3362 7.3487 18.3362H13.6487C14.2418 18.3362 14.8292 18.2194 15.3772 17.9924C15.9251 17.7654 16.4231 17.4327 16.8425 17.0133C17.2619 16.5939 17.5946 16.096 17.8216 15.548C18.0485 15 18.1654 14.4127 18.1654 13.8195V9.07787C18.1654 8.89663 18.0934 8.72282 17.9652 8.59467C17.8371 8.46653 17.6633 8.39453 17.482 8.39453H3.51536C3.33413 8.39453 3.16032 8.46653 3.03217 8.59467C2.90403 8.72282 2.83203 8.89663 2.83203 9.07787Z"
        fill="#A1A5B7"
      />
      <path
        d="M17.8728 6.31797C17.9116 6.42208 17.9248 6.53401 17.9112 6.64429C17.8976 6.75457 17.8577 6.85995 17.7947 6.95151C17.7318 7.04308 17.6477 7.11813 17.5496 7.17031C17.4515 7.22249 17.3423 7.25027 17.2311 7.2513H3.89781C3.76199 7.25226 3.628 7.22001 3.5075 7.15735C3.38699 7.0947 3.28363 7.00354 3.2064 6.89181C3.12918 6.78008 3.08043 6.65117 3.06441 6.5163C3.04839 6.38142 3.06558 6.24468 3.11448 6.11797C3.36726 5.51184 3.7485 4.96774 4.23189 4.52319C4.71528 4.07864 5.28934 3.74422 5.91448 3.54297V2.24297C5.91337 2.16785 5.92721 2.09327 5.95519 2.02355C5.98318 1.95384 6.02474 1.89038 6.07747 1.83688C6.1302 1.78337 6.19305 1.74088 6.26235 1.71189C6.33165 1.68289 6.40602 1.66796 6.48114 1.66797C6.63364 1.66797 6.77989 1.72855 6.88773 1.83638C6.99556 1.94422 7.05614 2.09047 7.05614 2.24297V3.33464C7.16447 3.33464 7.23114 3.33464 7.32281 3.33464H10.0478V2.24297C10.0478 2.09047 10.1084 1.94422 10.2162 1.83638C10.3241 1.72855 10.4703 1.66797 10.6228 1.66797C10.7753 1.66797 10.9216 1.72855 11.0294 1.83638C11.1372 1.94422 11.1978 2.09047 11.1978 2.24297V3.33464H13.6145C13.7061 3.33464 13.7895 3.33464 13.8811 3.33464V2.24297C13.88 2.16785 13.8939 2.09327 13.9219 2.02355C13.9498 1.95384 13.9914 1.89038 14.0441 1.83688C14.0969 1.78337 14.1597 1.74088 14.229 1.71189C14.2983 1.68289 14.3727 1.66796 14.4478 1.66797C14.6003 1.66797 14.7466 1.72855 14.8544 1.83638C14.9622 1.94422 15.0228 2.09047 15.0228 2.24297V3.54297C15.677 3.75951 16.2734 4.12181 16.7671 4.60252C17.2608 5.08324 17.6389 5.66981 17.8728 6.31797ZM7.77281 10.8346C7.63308 10.8363 7.49696 10.8792 7.38158 10.958C7.26619 11.0369 7.1767 11.1481 7.12437 11.2776C7.07203 11.4072 7.05919 11.5493 7.08745 11.6862C7.11572 11.823 7.18383 11.9485 7.28321 12.0467C7.3826 12.1449 7.50882 12.2116 7.64599 12.2382C7.78316 12.2649 7.92515 12.2504 8.0541 12.1965C8.18305 12.1427 8.29318 12.0519 8.37065 11.9356C8.44812 11.8193 8.48947 11.6827 8.48948 11.543C8.48728 11.3543 8.41081 11.1742 8.27664 11.0416C8.14248 10.909 7.96144 10.8346 7.77281 10.8346ZM10.4478 10.8346C10.3081 10.8363 10.172 10.8792 10.0566 10.958C9.94119 11.0369 9.8517 11.1481 9.79937 11.2776C9.74703 11.4072 9.73419 11.5493 9.76245 11.6862C9.79072 11.823 9.85883 11.9485 9.95821 12.0467C10.0576 12.1449 10.1838 12.2116 10.321 12.2382C10.4582 12.2649 10.6002 12.2504 10.7291 12.1965C10.858 12.1427 10.9682 12.0519 11.0457 11.9356C11.1231 11.8193 11.1645 11.6827 11.1645 11.543C11.1623 11.3543 11.0858 11.1742 10.9516 11.0416C10.8175 10.909 10.6364 10.8346 10.4478 10.8346ZM13.1478 10.8346C13.0548 10.8346 12.9627 10.853 12.8767 10.8886C12.7908 10.9242 12.7127 10.9763 12.6469 11.0421C12.5812 11.1079 12.529 11.186 12.4934 11.2719C12.4578 11.3578 12.4395 11.45 12.4395 11.543C12.4395 11.636 12.4578 11.7281 12.4934 11.814C12.529 11.9 12.5812 11.9781 12.6469 12.0438C12.7127 12.1096 12.7908 12.1618 12.8767 12.1974C12.9627 12.233 13.0548 12.2513 13.1478 12.2513C13.2408 12.2513 13.3329 12.233 13.4189 12.1974C13.5048 12.1618 13.5829 12.1096 13.6487 12.0438C13.7145 11.9781 13.7666 11.9 13.8022 11.814C13.8378 11.7281 13.8561 11.636 13.8561 11.543C13.8561 11.45 13.8378 11.3578 13.8022 11.2719C13.7666 11.186 13.7145 11.1079 13.6487 11.0421C13.5829 10.9763 13.5048 10.9242 13.4189 10.8886C13.3329 10.853 13.2408 10.8346 13.1478 10.8346ZM7.76448 13.5013C7.62475 13.5029 7.48863 13.5459 7.37324 13.6247C7.25786 13.7035 7.16837 13.8147 7.11603 13.9443C7.0637 14.0739 7.05085 14.216 7.07912 14.3529C7.10738 14.4897 7.17549 14.6151 7.27488 14.7134C7.37426 14.8116 7.50048 14.8782 7.63766 14.9049C7.77483 14.9316 7.91682 14.9171 8.04577 14.8632C8.17471 14.8094 8.28485 14.7186 8.36232 14.6023C8.43979 14.486 8.48113 14.3494 8.48114 14.2096C8.48115 14.1159 8.46255 14.0231 8.42644 13.9366C8.39032 13.8501 8.3374 13.7717 8.27074 13.7058C8.20408 13.6399 8.12501 13.5879 8.0381 13.5528C7.9512 13.5177 7.85819 13.5002 7.76448 13.5013ZM10.4395 13.5013C10.2997 13.5029 10.1636 13.5459 10.0482 13.6247C9.93286 13.7035 9.84337 13.8147 9.79103 13.9443C9.7387 14.0739 9.72585 14.216 9.75412 14.3529C9.78238 14.4897 9.85049 14.6151 9.94988 14.7134C10.0493 14.8116 10.1755 14.8782 10.3127 14.9049C10.4498 14.9316 10.5918 14.9171 10.7208 14.8632C10.8497 14.8094 10.9598 14.7186 11.0373 14.6023C11.1148 14.486 11.1561 14.3494 11.1561 14.2096C11.1561 14.1159 11.1376 14.0231 11.1014 13.9366C11.0653 13.8501 11.0124 13.7717 10.9457 13.7058C10.8791 13.6399 10.8 13.5879 10.7131 13.5528C10.6262 13.5177 10.5332 13.5002 10.4395 13.5013ZM13.1311 13.5013C12.9918 13.5046 12.8565 13.5489 12.7423 13.6287C12.628 13.7085 12.5398 13.8202 12.4887 13.9499C12.4377 14.0796 12.426 14.2215 12.4552 14.3578C12.4844 14.494 12.5531 14.6187 12.6528 14.7161C12.7525 14.8135 12.8787 14.8793 13.0156 14.9053C13.1526 14.9313 13.2941 14.9164 13.4226 14.8623C13.551 14.8082 13.6607 14.7175 13.7378 14.6014C13.8149 14.4853 13.8561 14.349 13.8561 14.2096C13.8551 14.1155 13.8354 14.0225 13.7984 13.936C13.7614 13.8495 13.7077 13.7711 13.6404 13.7053C13.573 13.6395 13.4934 13.5877 13.406 13.5527C13.3187 13.5177 13.2253 13.5002 13.1311 13.5013Z"
        fill="#A1A5B7"
      />
    </svg>
  );
};

export const ChartDownloadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
    >
      <path
        d="M9.04345 6.62792L5.29358 10.3778C5.25488 10.4165 5.20893 10.4473 5.15835 10.4682C5.10777 10.4892 5.05355 10.5 4.99879 10.5C4.94404 10.5 4.88982 10.4892 4.83924 10.4682C4.78866 10.4473 4.74271 10.4165 4.70401 10.3778L0.954134 6.62792C0.875953 6.54974 0.832031 6.44371 0.832031 6.33314C0.832031 6.22258 0.875953 6.11654 0.954134 6.03836C1.03231 5.96018 1.13835 5.91626 1.24892 5.91626C1.35948 5.91626 1.46552 5.96018 1.5437 6.03836L4.58214 9.07732V0.916653C4.58214 0.80615 4.62604 0.700173 4.70418 0.622035C4.78231 0.543897 4.88829 0.5 4.99879 0.5C5.1093 0.5 5.21527 0.543897 5.29341 0.622035C5.37155 0.700173 5.41545 0.80615 5.41545 0.916653V9.07732L8.45389 6.03836C8.53207 5.96018 8.63811 5.91626 8.74867 5.91626C8.85924 5.91626 8.96527 5.96018 9.04345 6.03836C9.12163 6.11654 9.16556 6.22258 9.16556 6.33314C9.16556 6.44371 9.12163 6.54974 9.04345 6.62792Z"
        fill="white"
        stroke="white"
        stroke-width="0.5"
      />
    </svg>
  );
};
export const ChartAddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
    >
      <path
        d="M5.93125 9.20855H7.06875V7.06875H9.20855V5.93125H7.06875V3.79145H5.93125V5.93125H3.79145V7.06875H5.93125V9.20855ZM2.7625 11.375C2.4466 11.375 2.17793 11.2645 1.9565 11.0435C1.7355 10.8221 1.625 10.5534 1.625 10.2375V2.7625C1.625 2.4466 1.7355 2.17793 1.9565 1.9565C2.17793 1.7355 2.4466 1.625 2.7625 1.625H10.2375C10.5534 1.625 10.8221 1.7355 11.0435 1.9565C11.2645 2.17793 11.375 2.4466 11.375 2.7625V10.2375C11.375 10.5534 11.2645 10.8221 11.0435 11.0435C10.8221 11.2645 10.5534 11.375 10.2375 11.375H2.7625ZM2.7625 10.2375H10.2375V2.7625H2.7625V10.2375ZM2.7625 10.2375V2.7625V10.2375Z"
        fill="white"
      />
    </svg>
  );
};
export const ChartEditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
    >
      <path
        d="M2.78646 10.2943H3.54479L8.98854 4.86406L8.60938 4.47135L8.21667 4.09219L2.78646 9.53594V10.2943ZM1.70312 11.3776V9.07552L8.98854 1.80365C9.19618 1.59601 9.45131 1.49219 9.75392 1.49219C10.0562 1.49219 10.3111 1.59601 10.5188 1.80365L11.2771 2.57552C11.4847 2.78316 11.5885 3.03594 11.5885 3.33385C11.5885 3.63177 11.4847 3.88455 11.2771 4.09219L4.00521 11.3776H1.70312ZM10.5052 3.33385L9.74688 2.57552L10.5052 3.33385ZM8.98854 4.86406L8.60938 4.47135L8.21667 4.09219L8.98854 4.86406Z"
        fill="white"
      />
    </svg>
  );
};

export const Envelope = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.668 4.9987H10.0013L8.33464 3.33203H3.33464C2.41797 3.33203 1.6763 4.08203 1.6763 4.9987L1.66797 14.9987C1.66797 15.9154 2.41797 16.6654 3.33464 16.6654H16.668C17.5846 16.6654 18.3346 15.9154 18.3346 14.9987V6.66536C18.3346 5.7487 17.5846 4.9987 16.668 4.9987ZM11.668 13.332H5.0013V11.6654H11.668V13.332ZM15.0013 9.9987H5.0013V8.33203H15.0013V9.9987Z"
        fill="#CDD0DA"
      />
    </svg>
  );
};

export const DefaultStepper = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <circle cx="16" cy="16" r="15" stroke="#3699FF" stroke-width="2" />
      <circle cx="16" cy="16" r="5" fill="#3699FF" />
    </svg>
  );
};

export const ActiveStepper = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#3699FF" />
      <path
        d="M10.168 16.832L13.5013 20.1654L21.8346 11.832"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const InactiveStepper = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <circle cx="16" cy="16" r="15" stroke="#D1D5DB" stroke-width="2" />
    </svg>
  );
};

export const TemperatureIcon = () => {
  return (
    <svg
      width="8"
      height="9"
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4.24219" r="4" fill="#EB5757" />
    </svg>
  );
};

export const SortByFilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <rect width="22" height="22" fill="none" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.7091 7.79472C10.7139 7.51769 10.6111 7.24957 10.4222 7.04685L6.1334 2.75803C6.03335 2.65785 5.9144 2.57854 5.78346 2.52469C5.65251 2.47084 5.51218 2.44354 5.37059 2.44435C5.21124 2.44422 5.05388 2.47975 4.91005 2.54834C4.76622 2.61692 4.63955 2.71683 4.53935 2.84073L0.340351 7.04115C0.235288 7.13905 0.15102 7.25711 0.0925736 7.38828C0.034127 7.51945 0.00269977 7.66106 0.000166422 7.80464C-0.00236693 7.94822 0.0240456 8.09084 0.0778284 8.224C0.131611 8.35715 0.211663 8.47811 0.313207 8.57965C0.414751 8.68119 0.535707 8.76125 0.668861 8.81503C0.802014 8.86881 0.944636 8.89522 1.08822 8.89269C1.2318 8.89016 1.3734 8.85873 1.50458 8.80028C1.63575 8.74184 1.75381 8.65757 1.85171 8.55251L4.30124 6.10297V18.4861C4.30124 18.7697 4.4139 19.0417 4.61445 19.2422C4.81499 19.4428 5.08698 19.5554 5.37059 19.5554C5.6542 19.5554 5.9262 19.4428 6.12674 19.2422C6.32728 19.0417 6.43995 18.7697 6.43995 18.4861V6.09014L8.91087 8.55821C9.11358 8.7471 9.3817 8.84993 9.65874 8.84504C9.93577 8.84016 10.2001 8.72793 10.396 8.532C10.5919 8.33608 10.7042 8.07176 10.7091 7.79472ZM10.8013 14.6044C10.8598 14.7355 10.9441 14.8536 11.0491 14.9515L15.3379 19.2403C15.438 19.3405 15.5569 19.4198 15.6879 19.4737C15.8188 19.5275 15.9592 19.5548 16.1007 19.554C16.2601 19.5541 16.4175 19.5186 16.5613 19.45C16.7051 19.3814 16.8318 19.2815 16.932 19.1576L21.131 14.9572C21.2361 14.8593 21.3203 14.7413 21.3788 14.6101C21.4372 14.4789 21.4686 14.3373 21.4712 14.1937C21.4737 14.0501 21.4473 13.9075 21.3935 13.7744C21.3397 13.6412 21.2597 13.5203 21.1581 13.4187C21.0566 13.3172 20.9356 13.2371 20.8025 13.1833C20.6693 13.1295 20.5267 13.1031 20.3831 13.1057C20.2395 13.1082 20.0979 13.1396 19.9668 13.1981C19.8356 13.2565 19.7175 13.3408 19.6196 13.4459L17.1701 15.8954V3.51369C17.1701 3.23008 17.0574 2.95809 16.8569 2.75754C16.6564 2.557 16.3844 2.44434 16.1007 2.44434C15.8171 2.44434 15.5451 2.557 15.3446 2.75754C15.1441 2.95809 15.0314 3.23008 15.0314 3.51369V15.9096L12.5605 13.4401C12.4626 13.3351 12.3445 13.2508 12.2133 13.1924C12.0822 13.1339 11.9406 13.1025 11.797 13.1C11.6534 13.0974 11.5108 13.1238 11.3776 13.1776C11.2445 13.2314 11.1235 13.3115 11.022 13.413C10.9204 13.5145 10.8404 13.6355 10.7866 13.7687C10.7328 13.9018 10.7064 14.0444 10.7089 14.188C10.7115 14.3316 10.7429 14.4732 10.8013 14.6044Z"
        fill="#3699FF"
      />
    </svg>
  );
};

export const SoftwareCalendarIcon = ({
  fill="#3699FF"
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
    >
      <path
        d="M15.36 1.35108H12V0.248862C12 0.173084 11.928 0.111084 11.84 0.111084H10.72C10.632 0.111084 10.56 0.173084 10.56 0.248862V1.35108H5.44V0.248862C5.44 0.173084 5.368 0.111084 5.28 0.111084H4.16C4.072 0.111084 4 0.173084 4 0.248862V1.35108H0.64C0.286 1.35108 0 1.59736 0 1.9022V13.3378C0 13.6426 0.286 13.8889 0.64 13.8889H15.36C15.714 13.8889 16 13.6426 16 13.3378V1.9022C16 1.59736 15.714 1.35108 15.36 1.35108ZM14.56 12.6489H1.44V6.10442H14.56V12.6489ZM1.44 4.93331V2.59108H4V3.41775C4 3.49353 4.072 3.55553 4.16 3.55553H5.28C5.368 3.55553 5.44 3.49353 5.44 3.41775V2.59108H10.56V3.41775C10.56 3.49353 10.632 3.55553 10.72 3.55553H11.84C11.928 3.55553 12 3.49353 12 3.41775V2.59108H14.56V4.93331H1.44Z"
        fill={fill}
      />
    </svg>
  );
};

export const CheckmarkIcon = () => {
  return (
    <svg
      width="41"
      height="42"
      viewBox="0 0 41 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="41" height="41" rx="6" fill="#C5EEDB" />
      <rect
        x="8.67285"
        y="23.4124"
        width="4.7331"
        height="10.1736"
        rx="1"
        transform="rotate(-45 8.67285 23.4124)"
        fill="#18BC6D"
      />
      <rect
        x="30.0532"
        y="10.75"
        width="4.01089"
        height="24.0653"
        rx="1"
        transform="rotate(45 30.0532 10.75)"
        fill="#18BC6D"
      />
    </svg>
  );
};

export const ProductsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 6H17C17 3.2 14.8 1 12 1C9.2 1 7 3.2 7 6H5C3.9 6 3 6.9 3 8V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V8C21 6.9 20.1 6 19 6ZM12 3C13.7 3 15 4.3 15 6H9C9 4.3 10.3 3 12 3ZM19 20H5V8H19V20ZM12 12C10.3 12 9 10.7 9 9H7C7 11.8 9.2 14 12 14C14.8 14 17 11.8 17 9H15C15 10.7 13.7 12 12 12Z"
        fill="#70808F"
      />
    </svg>
  );
};

export const InventoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 16.5C21 16.88 20.79 17.21 20.47 17.38L12.57 21.82C12.41 21.94 12.21 22 12 22C11.79 22 11.59 21.94 11.43 21.82L3.53 17.38C3.21 17.21 3 16.88 3 16.5V7.5C3 7.12 3.21 6.79 3.53 6.62L11.43 2.18C11.59 2.06 11.79 2 12 2C12.21 2 12.41 2.06 12.57 2.18L20.47 6.62C20.79 6.79 21 7.12 21 7.5V16.5ZM12 4.15L10.11 5.22L16 8.61L17.96 7.5L12 4.15ZM6.04 7.5L12 10.85L13.96 9.75L8.08 6.35L6.04 7.5ZM5 15.91L11 19.29V12.58L5 9.21V15.91ZM19 15.91V9.21L13 12.58V19.29L19 15.91Z"
        fill="#70808F"
      />
    </svg>
  );
};
